export enum TranslateType {
    Summary = 'summary',
    Transcription = 'transcription'
}
